import React from 'react';
import { Shimmer } from '../../../../../../ui';
import { StyledItem } from '../item';
import { StyledAirlineColumn } from '../item/Airline';
import { StyledBaggageClaimColumn } from '../item/BaggageClaim';
import { StyledDescriptionColumn } from '../item/Description';
import { StyledDetailsLinkColumn } from '../item/DetailsLink';
import { StyledGateColumn } from '../item/Gate';
import { StyledStatusColumn } from '../item/Status';
import { StyledTimeColumn } from '../item/Time';
import { StyledTypeColumn } from '../item/Type';
import { TextPlaceholder } from './TextPlaceholder';

const ShimmerItem = Shimmer.withComponent(StyledItem);

export const FlightListItemShimmer = () => (
	<ShimmerItem>
		<StyledTimeColumn>
			<TextPlaceholder />
		</StyledTimeColumn>

		<StyledDescriptionColumn>
			<TextPlaceholder />
			<TextPlaceholder width="60%" />
		</StyledDescriptionColumn>

		<StyledTypeColumn>
			<TextPlaceholder />
		</StyledTypeColumn>

		<StyledStatusColumn>
			<TextPlaceholder />
		</StyledStatusColumn>

		<StyledAirlineColumn>
			<TextPlaceholder />
		</StyledAirlineColumn>

		<StyledGateColumn>
			<TextPlaceholder />
		</StyledGateColumn>

		<StyledBaggageClaimColumn>
			<TextPlaceholder />
		</StyledBaggageClaimColumn>

		<StyledDetailsLinkColumn>
			<TextPlaceholder />
		</StyledDetailsLinkColumn>
	</ShimmerItem>
);
